import React, {useState, useEffect, useRef} from "react";

function PowerPointViewer({filePath, allowSkip, onEnded}) {
    const contentRef = useRef();

    useEffect(() => {
    }, []);

    const getIframe = () => {
    }

    return (
        <div style={{position: 'relative', width: '100%', height: '100%'}}>
            <iframe
                ref={contentRef}
                id="pptx-container"
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${filePath}&amp;wdStartOn=1&amp;wdPrint=0&amp;wdEmbedCode=1`}
                frameBorder={0}
                style={{width: '100%', height: '100%'}}
            />
            <div
                style={{
                    position: 'absolute',
                    bottom: 3,
                    right: 1,
                    width: 90,
                    height: 20,
                    backgroundColor: 'rgb(68, 68, 68)',
                    zIndex: 2,
                }}
            />
        </div>
    )
}

export default PowerPointViewer;